import { Check, ChevronDown, ChevronUp, Plus, Search } from "lucide-react";
import React, { useState, useEffect, useCallback } from "react";

export default function UserHeader({ onSearch }) {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [searchInput, setSearchInput] = useState('');
  
  // Add debounce to prevent excessive API calls
  const debounce = (func, wait) => {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func(...args), wait);
    };
  };
  
  // Create debounced search handler
  const debouncedSearch = useCallback(
    debounce(value => {
      onSearch(value);
    }, 500),
    [onSearch]
  );

  const handleInputChange = (e) => {
    const value = e.target.value;
    setSearchInput(value);
    debouncedSearch(value);
  };

  // Initialize search from URL if present
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const searchParam = params.get('search');
    if (searchParam) {
      setSearchInput(searchParam);
      // Don't need to call onSearch here as it would trigger unnecessary API call
    }
  }, []);

  const GAMES = ["Active", "Inactive"];

  return (
    <>
      <div className="px-4 flex justify-between items-center">
        <div className="flex-1 relative p-2 border border-[#E1E7EF] rounded-md">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 " />
          <input
            value={searchInput}
            onChange={handleInputChange}
            placeholder="Search Users"
            className="pl-8 w-full text-xs font-normal outline-none focus:border-transparent"
          />
        </div>
      </div>
    </>
  );
}
